<script setup>
import { useMapGetter } from 'dashboard/composables/store.js';

import SearchResultSection from './SearchResultSection.vue';
import SearchResultEventItem from './SearchResultEventItem.vue';

defineProps({
  events: { type: Array, default: () => [] },
  query: { type: String, default: '' },
  isFetching: { type: Boolean, default: false },
  showTitle: { type: Boolean, default: true },
});

const accountId = useMapGetter('getCurrentAccountId');
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.EVENTS')"
    :empty="!events.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="events.length" class="space-y-3 list-none">
      <li v-for="event in events" :key="event.id">
        <SearchResultEventItem
          :id="event.id"
          :name="event.name"
          :description="event.description"
          :system-stage="event.systemStage"
          :custom-status="event.customStatus"
          :account-id="accountId"
          :start-date="event.startDate"
          :end-date="event.endDate"
        />
      </li>
    </ul>
  </SearchResultSection>
</template>
